import Faith5 from '../images/Faith5.jpg';
// import LibertyMorality from '../LibertyMorality.jpg';

function FaithEmbed(){
    return (
        <>
        <img src={Faith5} alt="Statue of Faith - National Monument to the Forefathers" className="faithImage" />
        </>
    );
};
export default FaithEmbed;